import {h, Fragment} from "preact"
import { useAppState, AutocompleteElement } from "@nosto/preact"
import { useEffect, useState } from 'preact/hooks'
import { fetchPopularSearches } from "../helpers"
import { defaultConfig } from "../config"

export default function History() {
    // const [ popularSearches, setPopularSearches ] = useState(null);

    // useEffect(async () => {
    //     try {
    //         const data = await fetchPopularSearches();
    //         setPopularSearches(data);
    //     } catch (error) {
    //         console.warn("[History.jsx] error fetching popular searches", error)
    //     }
    // }, [])

    const popularSearches = [
        { query: 'jellycat' },
        { query: 'fawn' },
        { query: 'cardigan' },
        { query: 'tartan' }
    ]

    return (
        <div class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto">
            <div class="ns-w-100 ns-mt-sm-auto">
            <div class="ns-autoc-container ns-container">
                    {popularSearches?.length > 0 && (
                        <div class='ns-autocomplete-keywords v-stack gap-6 sm:gap-8 ns-d-flex ns-flex-column ns-col-12 ns-col-sm-20'>
                            <div class="ns-auto-title">
                                POPULAR SEARCHES
                            </div>
                            <div class="ns-predictive-search__suggestions ns-d-flex">
                                {popularSearches.map(item => (
                                    <AutocompleteElement
                                        key={item?.query}
                                        hit={{ keyword: item?.query }}
                                        class="ns-clickable"
                                    >
                                        {item?.query}
                                    </AutocompleteElement>
                                ))}
                            </div>
                        </div>
                    )}
                    {/* <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1" /> */}
                </div>
            </div>
        </div>
    )
}
